import { graphql } from 'gql';

export const uerRatioUerRowItemsForWorkOrderObjects = graphql(`
    query uerRatioUerRowItemsForWorkOrderObjects(
        $skip: Int
        $take: Int
        $ratioRowId: Long!
        $workOrderObjectIds: [Long!]!
        $where: RatioUerRowItemFilterInput
        $order: [RatioUerRowItemSortInput!]
    ) {
        uerRatioUerRowItemsForWorkOrderObjects(
            skip: $skip
            take: $take
            ratioRowId: $ratioRowId
            workOrderObjectIds: $workOrderObjectIds
            where: $where
            order: $order
        ) {
            items {
                appliesToCode
                appliesToCodeName
                appliesToId
                appliesToLinkStatus
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerRatioUerRowItemsForWorkOrderRootObject = graphql(`
    query uerRatioUerRowItemsForWorkOrderRootObject(
        $skip: Int
        $take: Int
        $ratioRowId: Long!
        $rootObjectId: Long!
        $where: RatioUerRowItemFilterInput
        $order: [RatioUerRowItemSortInput!]
    ) {
        uerRatioUerRowItemsForWorkOrderRootObject(
            skip: $skip
            take: $take
            ratioRowId: $ratioRowId
            rootObjectId: $rootObjectId
            where: $where
            order: $order
        ) {
            items {
                appliesToCode
                appliesToCodeName
                appliesToId
                appliesToLinkStatus
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerApplyRatioToWorkOrderObjects = graphql(`
    mutation uerApplyRatioToWorkOrderObjects($workOrderObjectIds: [Long!]!, $priceListRatioIds: [Long!]!) {
        uerApplyRatioToWorkOrderObjects(
            workOrderObjectIds: $workOrderObjectIds
            priceListRatioIds: $priceListRatioIds
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerApplyWorkOrderPriceRatiosToRootObject = graphql(`
    mutation uerApplyWorkOrderPriceRatiosToRootObject($workOrderObjectId: Long!, $priceListRatioIds: [Long!]!) {
        uerApplyWorkOrderPriceRatiosToRootObject(
            workOrderObjectId: $workOrderObjectId
            priceListRatioIds: $priceListRatioIds
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerRatioUerRowItemListForWorkOrderRootObject = graphql(`
    query uerRatioUerRowItemListForWorkOrderRootObject(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $ratioRowId: Long!
        $rootObjectIds: WorkOrderChangeObjectIdInput!
        $constructionTypeId: Int!
        $where: PriceListRatioUerRowForWorkOrderChangeFilterInput
        $order: [PriceListRatioUerRowForWorkOrderChangeSortInput!]
    ) {
        uerRatioUerRowItemListForWorkOrderRootObject(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            ratioRowId: $ratioRowId
            rootObjectIds: $rootObjectIds
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                appliesToCode
                appliesToCodeName
                appliesToId
                appliesToLinkStatus
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerRatioUerRowItemListForWorkOrderObjects = graphql(`
    query uerRatioUerRowItemListForWorkOrderObjects(
        $skip: Int
        $take: Int
        $ratioRowId: Long!
        $workOrderChangeId: Long!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $constructionTypeId: Int!
        $where: PriceListRatioUerRowForWorkOrderChangeFilterInput
        $order: [PriceListRatioUerRowForWorkOrderChangeSortInput!]
    ) {
        uerRatioUerRowItemListForWorkOrderObjects(
            skip: $skip
            take: $take
            ratioRowId: $ratioRowId
            workOrderChangeId: $workOrderChangeId
            objectIds: $objectIds
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            items {
                appliesToCode
                appliesToCodeName
                appliesToId
                appliesToLinkStatus
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerApplyWorkOrderChangePriceRatiosToObjects = graphql(`
    mutation uerApplyWorkOrderChangePriceRatiosToObjects(
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $priceListRatioIds: [PriceListRatioRowInput!]!
    ) {
        uerApplyWorkOrderChangePriceRatiosToObjects(
            objectIds: $objectIds
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            priceListRatioIds: $priceListRatioIds
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerApplyWorkOrderChangePriceRatiosToRootObject = graphql(`
    mutation uerApplyWorkOrderChangePriceRatiosToRootObject(
        $rootObjectIds: WorkOrderChangeObjectIdInput!
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $priceListRatioIds: [PriceListRatioRowInput!]!
    ) {
        uerApplyWorkOrderChangePriceRatiosToRootObject(
            rootObjectIds: $rootObjectIds
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            priceListRatioIds: $priceListRatioIds
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);
